import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'your-project-url'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'your-anon-key'

// Create Supabase client with optimized real-time configuration for cross-browser compatibility
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'X-Client-Info': 'ilanot-parents-hub'
    }
  }
})

// Types for our database tables
export interface VolunteerSlot {
  id: string
  date: string
  class_name: string
  volunteer_name: string | null
  volunteer_email: string | null
  created_at: string
}

export interface AuditLog {
  id: string
  timestamp: string
  action: 'REGISTER' | 'CANCEL' | 'MODIFY' | 'VIEW'
  slot_id?: string
  slot_date: string
  class_name: string
  user_name?: string
  user_email?: string
  ip_address?: string
  user_agent?: string
  session_id?: string
  old_values?: Record<string, any>
  new_values?: Record<string, any>
  notes?: string
  created_at: string
}